/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useCompanyLoanConfigurationsGetAll = makeQueryHook(
  operations.companyLoanConfigurationsGetAll,
)

export const useCompanyLoanConfigurationsAdd = makeMutationHook(
  operations.companyLoanConfigurationsAdd,
)

export const useCompanyLoanConfigurationsGet = makeQueryHook(
  operations.companyLoanConfigurationsGet,
)

export const useCompanyLoanConfigurationsUpdate = makeMutationHook(
  operations.companyLoanConfigurationsUpdate,
)

export const useCompanyLoanConfigurationsDelete = makeMutationHook(
  operations.companyLoanConfigurationsDelete,
)

export const useLoansGetByLoanType = makeQueryHook(
  operations.loansGetByLoanType,
)

export const useInternalLoanTypeIndexRateGetAll = makeQueryHook(
  operations.internalLoanTypeIndexRateGetAll,
)

export const useInternalLoanTypeIndexRateAdd = makeMutationHook(
  operations.internalLoanTypeIndexRateAdd,
)

export const useInternalLoanTypeIndexRateGet = makeQueryHook(
  operations.internalLoanTypeIndexRateGet,
)

export const useInternalLoanTypeIndexRateUpdate = makeMutationHook(
  operations.internalLoanTypeIndexRateUpdate,
)

export const useInternalLoanTypeIndexRateDelete = makeMutationHook(
  operations.internalLoanTypeIndexRateDelete,
)

export const useLoanTypeDynamicFeeGetAll = makeQueryHook(
  operations.loanTypeDynamicFeeGetAll,
)

export const useLoanTypeDynamicFeeTypeAdd = makeMutationHook(
  operations.loanTypeDynamicFeeTypeAdd,
)

export const useLoanTypeDynamicFeeTypeGet = makeQueryHook(
  operations.loanTypeDynamicFeeTypeGet,
)

export const useInternalFeeTypesGet = makeQueryHook(
  operations.internalFeeTypesGet,
)

export const useTransactionsGetLoansWithScheduledReversals = makeQueryHook(
  operations.transactionsGetLoansWithScheduledReversals,
)

export const useTransactionsGetRawInternalHandler = makeQueryHook(
  operations.transactionsGetRawInternalHandler,
)

export const useFeeTypesGet = makeQueryHook(operations.feeTypesGet)

export const useGetLoanTypeCompanyConfigOverride = makeQueryHook(
  operations.getLoanTypeCompanyConfigOverride,
)

export const useSetLoanTypeCompanyConfigOverride = makeMutationHook(
  operations.setLoanTypeCompanyConfigOverride,
)

export const useGetLoanTypeChargedoffPaidoffPeriodsWithoutStatements =
  makeQueryHook(operations.getLoanTypeChargedoffPaidoffPeriodsWithoutStatements)

export const useLoanTypeIndexRateGetAll = makeQueryHook(
  operations.loanTypeIndexRateGetAll,
)

export const useLoanTypeIndexRateAdd = makeMutationHook(
  operations.loanTypeIndexRateAdd,
)

export const useLoanTypeIndexRateGet = makeQueryHook(
  operations.loanTypeIndexRateGet,
)

export const useLoanTypeIndexRateUpdate = makeMutationHook(
  operations.loanTypeIndexRateUpdate,
)

export const useLoanTypeIndexRateDelete = makeMutationHook(
  operations.loanTypeIndexRateDelete,
)
